import { render, staticRenderFns } from "./l22heatmap.vue?vue&type=template&id=520dc958&"
import script from "./l22heatmap.vue?vue&type=script&lang=js&"
export * from "./l22heatmap.vue?vue&type=script&lang=js&"
import style0 from "./l22heatmap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports